module.exports = __webpack_public_path__ + "img/redbull.a7dab3a4.png";